
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Button, Modal, Grid } from 'semantic-ui-react'
import { getHasError, getError } from '../selectors'
import { setError } from '../actions'
import { translate } from 'react-switch-lang';

class ErrorMessage extends React.Component {
	state = { open: this.props.hasError }

	close = () => {
		this.setState({ open: false })
		this.props.clearError()
	}

	UNSAFE_componentWillReceiveProps(nextProp) {
		this.setState({ open: nextProp.hasError })
	}

	render() {
		const { t } = this.props
		return (
			<Modal size={"small"} open={this.state.open} onClose={this.close}>
				<Modal.Header>{t('error.systemMessage')}</Modal.Header>
				<Modal.Content>
					{
						this.props.hasError
							&& this.props.error
							&& this.props.error.code !== undefined
							&& this.props.error.message !== undefined
							? <Modal.Description>
								<Grid>
									<Grid.Row>
										<Grid.Column width={2}>{t('error.code')}</Grid.Column>
										<Grid.Column width={14}>{this.props.error.code}</Grid.Column>
									</Grid.Row>
									<Grid.Row>
										<Grid.Column width={2}>{t('error.message')}</Grid.Column>
										<Grid.Column width={14}>
											{
												t(`error.${this.props.error.code}`).includes(this.props.error.code) ?
													this.props.error.message
													: t(`error.${this.props.error.code}`)
											}
										</Grid.Column>
									</Grid.Row>
								</Grid>
								{/* <p> </p>
								<p>{ {this.props.error.message}</p> */}
							</Modal.Description>
							:
							<p>{t('error.00000000')}</p>
					}
				</Modal.Content>
				<Modal.Actions>
					<Button basic color='blue' className='okButton' onClick={this.close}
						onClose={this.close} >{t('button.ok')}</Button>
				</Modal.Actions>
			</Modal>
		)
	}
}

export default compose(
	connect(
		(state, props) => ({
			hasError: getHasError(state),
			error: getError(state),
		}),
		(dispatch) => ({
			clearError() {
				dispatch(setError(false))
			},
		})
	)

)(translate(ErrorMessage))


// WEBPACK FOOTER //
// ./src/features/ui/components/ErrorMessageDialog.js